import React from "react";

import * as styles from "./styles";
import CreateAI from "../CreateAI/CreateAI";
import ImageSuggestion from "./ImageSuggestion";
import { SparklesIcon } from "components/navigation/icons";
import { CREATE_AI_NEW_UNTIL_MILLIS } from "constants/featureAnnouncements";
import { useComposerTools } from "../CreateAI/useComposerTools";
import { deriveComposerIssues } from "../CreateAI/composerIssues";
import { useComposerActions, useComposerState } from "contextApi/composerContext";

type CreateAiTool = "createAI" | "imageSuggestion";

interface ITool {
  label: string;
  icon: React.ReactNode;
}

const TOOLS: Record<CreateAiTool, ITool> = {
  createAI: { label: "Create AI", icon: <SparklesIcon size={16} /> },
  imageSuggestion: { label: "Stock photos", icon: <i className="icon-image" /> }
};
const TOOL_ORDER: CreateAiTool[] = ["createAI", "imageSuggestion"];

const CreateAiToolkit: React.FC = () => {
  const activeToolkit = useComposerState(state => state.activeToolkit);
  const setActiveToolkit = useComposerActions(actions => actions.setActiveToolkit);
  const { getSnapshot } = useComposerTools();
  const hasComposerIssues = deriveComposerIssues(getSnapshot()).length > 0;
  const isCreateAiNew = Date.now() < CREATE_AI_NEW_UNTIL_MILLIS;
  const shownTool: CreateAiTool = activeToolkit === "imageSuggestion" ? "imageSuggestion" : "createAI";

  return (
    <styles.Panel>
      <styles.PanelHeader>
        <styles.Tabs role="tablist" aria-label="Composer tools">
          {TOOL_ORDER.map(key => {
            const isActive = shownTool === key;
            return (
              <styles.Tab
                key={key}
                type="button"
                role="tab"
                aria-selected={isActive}
                $active={isActive}
                onClick={() => setActiveToolkit(key)}
              >
                {TOOLS[key].icon}
                {TOOLS[key].label}
                {key === "createAI" && isCreateAiNew && <styles.NewSticker>New</styles.NewSticker>}
                {key === "createAI" && !isActive && hasComposerIssues && <styles.TabBadge aria-label="Create AI has a suggestion" />}
              </styles.Tab>
            );
          })}
        </styles.Tabs>
      </styles.PanelHeader>
      <styles.PanelBody>{shownTool === "createAI" ? <CreateAI /> : <ImageSuggestion />}</styles.PanelBody>
    </styles.Panel>
  );
};

export default CreateAiToolkit;
